<template>
  <v-app id="inspire">
       <SnackBar></SnackBar>
    <Navigation v-if="isLoggedIn"></Navigation>

    <v-main>
      <v-container fluid fill-height>
        <v-layout justify-center>
          <v-flex text-xs-center>

            <router-view></router-view>

          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
    <v-footer color="primary" app>
      <span class="white--text">&copy; 2020</span>
    </v-footer>
  </v-app>
</template>

<script>
import SnackBar from './components/navigation/Snackbar.vue';
import Navigation from './components/navigation/Navigation.vue';

export default {
  name: 'App',
  components: {
    SnackBar,
    Navigation,
  },

  data: () => ({
    drawer: null,
  }),

  computed: {
    isLoggedIn() {
      return this.$store.getters['auth/isLoggedIn'];
    },
  },

  props: {
    source: String,
  },
};
</script>
